import { Pipe, PipeTransform } from '@angular/core';
import { isFunction } from '../utils/utils';

@Pipe({
  name: 'range'
})
export class RangePipe implements PipeTransform {
  transform(input: number[], total: number = 0, start: number = 0, increment: number = 1, cb?: Function): any {
    for (var i = 0; i < total; i++) {
      var j = start + i * increment;
      input.push(isFunction(cb) ? cb(j) : j);
    }
    return input;
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./node_modules/ng-pipes/src/collection/range.pipe.ts